import React, { useEffect, useState } from 'react';
import CTA from './CTA';
import './header.css';
import ME from '../../assets/me-l.png';
import HeaderSocials from './HeaderSocials';
import { AiOutlineArrowRight } from 'react-icons/ai';

const Header = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(50 - Math.random() * 1);
  const [index, setIndex] = useState(1);
  const toRotate = [
    'Desarrollador Junior - Frontend & Backend',
    'Graduado en sistemas microinformáticos y redes',
    'Editor de vídeo e imagen',
  ];
  const period = 1000;

  useEffect(() => {
    let ticker = setInterval(tick, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(100);
    } else {
      setIndex((prevIndex) => prevIndex + 1);
    }
  };

  return (
    <header>
      <div id='home' className='container header__container'>
        <h5> ¡Hola! Me llamo</h5>
        <h1> Adán Pérez Rodríguez</h1>

        {/* Llamada a la función de escribir/eliminar texto */}
        <h4>
          <span
            className='txt-rotate'
            dataPeriod='2000'
            data-rotate='[ "Desarrollador Junior - Frontend & Backend", "Graduado en sistemas microinformáticos y redes", "Editor de vídeo e imagen" ]'>
            <span className='wrap'>{text}</span>
          </span>
        </h4>
        {/* Fin Llamada a la función */}

        <CTA />
        <HeaderSocials />
        <div className='me'>
          <img src={ME} alt='me' />
        </div>

        <a href='#projects' className='scroll_down'>
          Scroll Down <AiOutlineArrowRight className='scroll_down-arrow' />
        </a>
      </div>
    </header>
  );
};

export default Header;
